module.exports = __webpack_public_path__ + "img/IMG_3539_L_WoodMatted_MockedUp.45fd6c68.jpg";